import React from 'react';

export default class Caracteristicas extends React.Component {

    render(){
    
      return(
        <>

            <section className="page-section text-white mb-0 caracteristicas" id="caracteristicas">
                <div className="container">

                {/* About Section Heading */}
                <h2 className="page-section-heading text-center text-uppercase text-white">Características da Loja</h2>

                {/* Icon Divider */}
                <div className="divider-custom divider-light">
                    <div className="divider-custom-line"></div>
                    <div className="divider-custom-icon">
                    <i className="fa fa-star"></i>
                    </div>
                    <div className="divider-custom-line"></div>
                </div>

                {/* About Section Content */}
                <div className="row">
                    <div className="col-lg-6 ml-auto">

                    <ul className="lstCaracteristicas">
                    <li >Cadastro de Produtos</li>
                    <li >Cadastro de Pedidos e Items de Pedido</li>
                    <li >Cálculo automático de frete (Pac e Sedex)</li>
                    <li >Área de Páginas (Quem somos, faq, etc...)</li>
                    <li >Área de Banners</li>
                    <li >Área de Parceiros</li>
                    <li >Área de Marcas de Produtos</li>
                    <li >Carrinho de Compras</li>
                    <li >Login - Novo Usuário - Esqueceu Senha</li>
                    <li >Pesquisa de Produtos</li>
                    <li >4 Niveis de Categorias de Produtos - Àrea, Grupo e Subgrupos</li>
                    <li >Formulário de Contato</li>
                    </ul>

                    </div>
  
  
                    <div className="col-lg-6 ml-auto">

                    <ul className="lstCaracteristicas">
                    <li >Depoimentos de Clientes</li>
                    <li >Rastrear objetos nos correios</li>
                    <li >Área do Cliente - Dados pessoais, Endereços e Pedidos</li>
                    <li >Criptografia de Senhas</li>
                    <li >Urls Amigáveis</li>
                    <li >Loja Responsiva adapatada a Tablets e Celulares</li>
                    <li >PagSeguro Implantado no formato transparente</li>
                    <li >Emails de Confirmação de Pagamento, Enviado, Novo Usuário e Esqueceu a senha</li>
                    <li >Integração do Link do Produto as redes sociais</li>
                    <li >Área Administrativa da Loja</li>
                    <li >Não sou um robô no formulário de contato</li>
                    </ul>

                    </div>
  
                </div>

                </div>
            </section>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#3d1154" fill-opacity="1" d="M0,160L0,160L36.9,160L36.9,288L73.8,288L73.8,160L110.8,160L110.8,256L147.7,256L147.7,192L184.6,192L184.6,256L221.5,256L221.5,32L258.5,32L258.5,32L295.4,32L295.4,288L332.3,288L332.3,224L369.2,224L369.2,192L406.2,192L406.2,64L443.1,64L443.1,320L480,320L480,256L516.9,256L516.9,128L553.8,128L553.8,192L590.8,192L590.8,256L627.7,256L627.7,256L664.6,256L664.6,288L701.5,288L701.5,32L738.5,32L738.5,128L775.4,128L775.4,128L812.3,128L812.3,64L849.2,64L849.2,192L886.2,192L886.2,64L923.1,64L923.1,224L960,224L960,32L996.9,32L996.9,96L1033.8,96L1033.8,192L1070.8,192L1070.8,96L1107.7,96L1107.7,128L1144.6,128L1144.6,160L1181.5,160L1181.5,96L1218.5,96L1218.5,64L1255.4,64L1255.4,128L1292.3,128L1292.3,96L1329.2,96L1329.2,64L1366.2,64L1366.2,32L1403.1,32L1403.1,128L1440,128L1440,0L1403.1,0L1403.1,0L1366.2,0L1366.2,0L1329.2,0L1329.2,0L1292.3,0L1292.3,0L1255.4,0L1255.4,0L1218.5,0L1218.5,0L1181.5,0L1181.5,0L1144.6,0L1144.6,0L1107.7,0L1107.7,0L1070.8,0L1070.8,0L1033.8,0L1033.8,0L996.9,0L996.9,0L960,0L960,0L923.1,0L923.1,0L886.2,0L886.2,0L849.2,0L849.2,0L812.3,0L812.3,0L775.4,0L775.4,0L738.5,0L738.5,0L701.5,0L701.5,0L664.6,0L664.6,0L627.7,0L627.7,0L590.8,0L590.8,0L553.8,0L553.8,0L516.9,0L516.9,0L480,0L480,0L443.1,0L443.1,0L406.2,0L406.2,0L369.2,0L369.2,0L332.3,0L332.3,0L295.4,0L295.4,0L258.5,0L258.5,0L221.5,0L221.5,0L184.6,0L184.6,0L147.7,0L147.7,0L110.8,0L110.8,0L73.8,0L73.8,0L36.9,0L36.9,0L0,0L0,0Z"></path></svg>

        </>
   );
}
}